import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { AdditionalContents, PleaseCheckYourNotifications } from "../../../../Constant";
import { ADDITIONAL_DATA, ADDITIONAL_LIST } from "../../../../Data/UiKit/Alert";
import { Alerts, H3, P } from "../../../../AbstractElements";

const AdditionalContent = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={AdditionalContents} span={ADDITIONAL_DATA} />
        <CardBody className="dark-alert">
          <Alerts color="light-primary">
            <H3 className="alert-heading pb-2 txt-primary">{PleaseCheckYourNotifications}</H3>
            <P>The duty of notification is imposed upon the head of the family, and also upon the medical practitioner who may be in attendance on the patient.</P>
            <hr />
            <P className="mb-0">The emergency notification system is free and is available in all 50 states.</P>
          </Alerts>
          {ADDITIONAL_LIST.map(({ color, title, paragraph1, paragraph2 }, index) => (
            <Alerts color={`light-${color}`} key={index}>
              <H3 className={`alert-heading pb-2 txt-${color}`}>{title}</H3>
              <P>{paragraph1}</P>
              <hr />
              <P className="mb-0">{paragraph2}</P>
            </Alerts>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default AdditionalContent;
